(function ($) {
    $(document).ready(function () {

        //************************************
        // Footer dropdowns
        //************************************

        $(".mobile-footer-menu").accordion({
            accordion: false,
            speed: 500,
            closedSign: '<i class="mobile-icon icon icon-arrow-down"></i>',
            openedSign: '<i class="mobile-icon icon icon-arrow-down"></i>'
        });

    });

})(jQuery);